import * as React from 'react';
import { SVGProps } from 'react';

const SvgArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='m9.879 20.092 1.06-1.06-6.677-6.678H21.86V10.86H4.262l6.677-6.677-1.06-1.06-8.486 8.485 8.486 8.485Z'
      fill='#000'
    />
  </svg>
);

export default SvgArrowLeft;
